import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import _ from 'lodash';

export class MessagingServerPlugin extends SmartenitPlugin {
  // Methods
  public getLastMessage() {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'GetLastMessage',
      {},
      false
    );
  }

  public messageConfirmation(messageID: number, confirmationTime: number) {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'MessageConfirmation',
      {
        ConfirmationTime: confirmationTime,
        MessageID: messageID
      },
      false
    );
  }

  public getConditionMethod(): string {
    return 'DisplayMessage.Message';
  }

  public getConditionAttribute(): any {
    return null;
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'DisplayMessageExtended') {
      this._onUpdate.next({ displayMessageExtended: response.value });
    } else if (attribute === 'CancelMessage') {
      this._onUpdate.next({ cancelMessage: response.value });
    }
  }
}
